'use strict';

namespace LangSwitcher {
    function languageSwitcher() {
        return {
            bindToController: {},
            restrict: 'E',
            replace: true,
            controller: 'LanguageSwitcher',
            controllerAs: 'ls',
            templateUrl:
                'partials/home/directivetemplate?type=LanguageSwitcher',
        };
    }

    class LanguageSwitcher {
        menu;
        enabled = true;

        constructor(
            private languageService: any,
            private $location: ng.ILocationService,
            private $scope: ng.IScope,
            private $route: ng.route.IRouteService
        ) {
            this.menu = false;
            this.$scope.$on('$routeChangeSuccess', () => {
                var path = $location.path();
                this.enabled = !/book/.test(path) && !/options/.test(path);
            });
        }

        public toggle() {
            this.menu = !this.menu;
        }

        public isRegionEnabled(region) {
            const host = this.$location.host();
            const exit = TRPCONFIG.Domain.EnabledRegionOnLangSelectorOverride;
            if (host && host.endsWith(exit)) {
                return true;
            }
            const regions =
            TRPCONFIG.Domain.EnabledRegionOnLangSelector.split(',') || [];
            return regions.includes(region);
        }

        public setLanguage(lang, id) {
            this.languageService.setLanguage(lang, id).then(() => {
                if (
                    TRPCONFIG.Domain.RedirectLanguageChangeToHomepage &&
                    TRPCONFIG.Domain.DomainId !== Number(id)
                ) {
                    window.location.href = '/?rl=1';
                } else {
                    window.location.href = this.$location.absUrl();
                }
            });
        }
    }

    angular
        .module('TR')
        .controller('LanguageSwitcher', LanguageSwitcher)
        .directive('languageSwitcher', languageSwitcher);
}
